export type StringFilterItem = {
    id: string,
    eventId: number,
    changeRequestId: number,
    name: string,
    source: string,
    authorEmail?: string,
    status?: string,
};

export type EventCodeSuggestions = {
    changeRequestItems: StringFilterItem[],
    eventItems: StringFilterItem[],
    summaryCaption: string,
};

export enum SuggestionType {
    EVENTS = 'Events',
    CHANGE_REQUEST = 'Change Requests',
}
